import { FC } from 'react'
import styled from 'styled-components'
import CloseButton from './CloseButton'
import Title from './Title'

interface IFJobCategoryBottomSheetTopProps {
  onClose: () => void
  className?: string
}

const JobCategoryBottomSheetTop: FC<IFJobCategoryBottomSheetTopProps> = ({
  onClose,
  className,
}) => {
  return (
    <StyledWrapper className={className}>
      <Title />
      <CloseButton onClick={onClose} className="close-button" />
    </StyledWrapper>
  )
}

export default JobCategoryBottomSheetTop

const StyledWrapper = styled.div`
  position: relative;
  padding: 23px 15px 15px 20px;
  border-bottom: 1px solid ${(props) => props.theme.line.line_3};

  .close-button {
    position: absolute;
    right: 25px;
    top: 20px;
  }
`
